import { useState, useEffect, useRef } from "react";
import BuyPlan from "../page/PlanPurchase/BuyPlan";


// Free-to-use Unsplash / Pexels CDN URLs — real people, healthcare context
const IMG = {
    heroBg: "https://aarogyaopd.com/assets/img/slider/b1.jpg",
    doctorPortrait: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=900&q=80&auto=format&fit=crop",
    familyIndian: "assets/img/a1.jpg",
    consultation: "assets/img/a0.jpg",
    labTest: "https://images.pexels.com/photos/4226219/pexels-photo-4226219.jpeg?auto=compress&cs=tinysrgb&w=900",
    telehealth: "https://images.pexels.com/photos/8376277/pexels-photo-8376277.jpeg?auto=compress&cs=tinysrgb&w=900",
    medicine: "https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg?auto=compress&cs=tinysrgb&w=900",
    elderly: "https://images.pexels.com/photos/7551617/pexels-photo-7551617.jpeg?auto=compress&cs=tinysrgb&w=900",
    wellness: "https://images.pexels.com/photos/3823495/pexels-photo-3823495.jpeg?auto=compress&cs=tinysrgb&w=900",
};

const partners = ["Tata 1mg", "HealthKart", "BeatO", "Toothai", "Manipal Hospitals", "PharmEasy"];

const benefits = [
    { img: IMG.medicine, title: "Savings on Daily Healthcare", desc: "Save up to 50% on doctor consultations, diagnostics, and medicines with your Aarogya OPD membership." },
    { img: IMG.telehealth, title: "Zero Waiting Periods", desc: "Benefits start from Day 1. No complicated claim forms, no waiting — just instant access to healthcare." },
    { img: IMG.consultation, title: "Seamless No-Claims Experience", desc: "Say goodbye to paperwork. Use your digital app and walk out — no bills to fight, no claims to file." },
    { img: IMG.labTest, title: "Pan-India Network of Specialists", desc: "500+ clinics and diagnostic centres across India. 17+ specialties, always just a few minutes away." },
    { img: IMG.elderly, title: "360° Primary Care Ecosystem", desc: "One membership for doctor visits, medicines, lab tests, mental wellness, dental, and preventive care." },
    { img: IMG.wellness, title: "Focus on Preventive Wellness", desc: "Regular health check-ups and wellness sessions to keep you healthy before illness strikes." },
];

const steps = [
    { num: "01", img: IMG.familyIndian, title: "Choose Your Plan", desc: "Pick the plan that fits — for yourself, your couple, or your entire family including parents and children." },
    { num: "02", img: IMG.telehealth, title: "Instant Activation", desc: "Complete registration via phone or email. Your benefits activate the moment you sign up — no delays." },
    { num: "03", img: IMG.consultation, title: "Book with Ease", desc: "Use the portal or app to find a doctor, book a diagnostic test, or order medicines in just a few clicks." },
];

const plans = [
    {
        name: "EasyCare",
        planCode: "AEC001Rokadaa",
        memberCount: 0,
        tag: "Member Coverage: Individual",
        tagColor: "#0657A3", tagBg: "#e8f0fb",
        price: 1299, priceGST: 1533,
        members: "1 Adult", ageRange: "18–65 yrs",
        note: "This Plan applicable for the age from 18 - 65 years",
        sections: [
            {
                label: null,
                items: [
                    "10 Credits on Tele Doctor Consultation: GP",
                    "2 Credits on Video Consultation–General Physician",
                ],
            },
            {
                label: "Group Personal Accident Rider",
                sublabel: "(Only for Primary Member)",
                items: [
                    "₹15 Lakh Sum Insured",
                    "Covered Accidental Death",
                    "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
                ],
            },
            {
                label: "Inclusive Benefits",
                items: [
                    "Applicable Risk Assessment",
                    "Applicable Health Reminder",
                    "Applicable Recorded Fitness sessions",
                ],
            },
            {
                label: "Platform Benefits",
                items: [
                    "Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)",
                    "Covered Upto 20% off on prescribed medicines",
                ],
            },
        ],
    },
    {
        name: "SmartCare",
        planCode: "ASC001Rokadaa",
        memberCount: 1,
        tag: "Member Coverage: 2 Adults",
        tagColor: "#085041", tagBg: "#e1f5ee",
        price: 2699, priceGST: 3185,
        members: "2 Adults", ageRange: "18–65 yrs",
        note: "This Plan applicable for the age from 18 - 65 years",
        sections: [
            {
                label: null,
                items: [
                    "10 Credits on Tele Doctor Consultation: GP",
                    "4 Credits on Tele Consultation (18 Specialist)",
                    "4 Credits on Video Consultation–General Physician",
                ],
            },
            {
                label: "Group Personal Accident Rider",
                sublabel: "(Only for Primary Member)",
                items: [
                    "₹15 Lakh Sum Insured",
                    "Covered Accidental Death",
                    "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
                ],
            },
            {
                label: "Inclusive Benefits",
                items: [
                    "Applicable Risk Assessment",
                    "Applicable Health Reminder",
                    "Applicable Recorded Fitness sessions",
                ],
            },
            {
                label: "Platform Benefits",
                items: [
                    "Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)",
                    "Covered Upto 20% off on prescribed medicines",
                ],
            },
        ],
    },
    {
        name: "TotalCare",
        planCode: "ATC001Rokadaa",
        memberCount: 3,
        tag: "Member Coverage: 4 Adults",
        tagColor: "#633806", tagBg: "#faeeda",
        price: 5199, priceGST: 6135,
        members: "4 Adults", ageRange: "0–85 yrs",
        note: "This Plan applicable for the age from 0 - 85 years",
        sections: [
            {
                label: null,
                items: [
                    "12 Credits on Tele Doctor Consultation: GP",
                    "4 Credits on Tele Doctor Consultation: Ayurvedic",
                    "4 Credits on Tele Doctor Consultation: Homeopathy",
                    "4 Credits on Tele Consultation (18 Specialist)",
                    "6 Credits on Video Consultation–General Physician",
                    "2 Credits on Mental Wellness",
                    "2 Credits on Dental Checkup & Consultation",
                    "2 Credits on Dietician Consultation",
                ],
            },
            {
                label: "Group Personal Accident Rider",
                sublabel: "(Only for Primary Member)",
                items: [
                    "₹15 Lakh Sum Insured",
                    "Covered Accidental Death",
                    "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
                ],
            },
            {
                label: "Inclusive Benefits",
                items: [
                    "Applicable Risk Assessment",
                    "Applicable Health Reminder",
                    "Applicable Recorded Fitness sessions",
                ],
            },
            {
                label: "Platform Benefits",
                items: [
                    "Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)",
                    "Covered Upto 20% off on prescribed medicines",
                ],
            },
        ],
    },
    {
        name: "EliteCare",
        planCode: "RokadaaEliteCare",
        memberCount: 3,
        tag: "Member Coverage: 4 Adults",
        tagColor: "#3C3489", tagBg: "#eeedfe",
        price: 10199, priceGST: 12035,
        members: "4 Adults", ageRange: "0–85 yrs",
        note: "This Plan applicable for the age from 0 - 85 years",
        sections: [
            {
                label: null,
                items: [
                    "12 Credits on Tele Doctor Consultation: GP",
                    "4 Credits on Tele Doctor Consultation: Ayurvedic",
                    "4 Credits on Tele Doctor Consultation: Homeopathy",
                    "6 Credits on Tele Consultation (18 Specialist)",
                    "2 Credits on Instant Doctor Consultation",
                    "₹1000 on Diagnostic & Radiology Wallet",
                    "8 Credits on Video Consultation–General Physician",
                    "2 Credits on Dental Checkup & Consultation",
                    "2 Credits on Mental Wellness",
                    "2 Credits on Dietician Consultation",
                ],
            },
            {
                label: "Group Personal Accident Rider",
                sublabel: "(Only for Primary Member)",
                items: [
                    "₹15 Lakh Sum Insured Cover 2 People",
                    "Covered Accidental Death",
                    "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
                ],
            },
            {
                label: "Inclusive Benefits",
                items: [
                    "Applicable Risk Assessment",
                    "Applicable Health Reminder",
                    "Applicable Recorded Fitness sessions",
                ],
            },
            {
                label: "Platform Benefits",
                items: [
                    "Covered Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount)",
                    "Covered Upto 20% off on prescribed medicines",
                ],
            },
        ],
    },
];

const testimonials = [
    { name: "Ankit Sharma", city: "Mumbai", stars: 5, text: "A plan that works instantly! I signed up in the morning and used my digital app for a specialist consultation the same afternoon. No claims, no waiting — just instant savings." },
    { name: "Meera Vasudevan", city: "Lucknow", stars: 5, text: "With two young kids, the pediatrician's office almost drained us monthly. Aarogya OPD saved us over ₹12,000 this year on consultation fees and lab tests alone." },
    { name: "Rajesh Gupta", city: "Delhi", stars: 5, text: "My blood sugar tests and monthly medicines used to be a huge financial burden. Now I get tests at half the price and medicines delivered with a great discount." },
];

const useInView = (threshold = 0.12) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
        if (ref.current) obs.observe(ref.current);
        return () => obs.disconnect();
    }, []);
    return [ref, inView];
};

// ── Anim wrapper — passes height:100% so card stretches to fill grid row ──────
const Anim = ({ children, style = {}, delay = 0 }) => {
    const [ref, inView] = useInView();
    return (
        <div ref={ref} style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(26px)",
            transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
            height: "100%",   // ← makes every Anim wrapper fill the grid cell
            ...style
        }}>
            {children}
        </div>
    );
};

const Check = () => (
    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
        <circle cx="9" cy="9" r="9" fill="#dcfce7" />
        <path d="M5 9l3 3 5-5" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);



export default function AarogyaOPD() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [showGST, setShowGST] = useState(false);

    // ── Buy Plan popup state — same as PlanPage ─────────────────────────
    const [openPopup, setOpenPopup] = useState(false);
    const [planCode, setPlanCode] = useState("");
    const [tenantId] = useState("T3341001XT8");
    const [isRider, setIsRider] = useState(false);
    const [showMember, setShowMember] = useState(false);
    const [memberCount, setMemberCount] = useState(0);

    // ── Buy Plan handler — exact same logic as PlanPage ─────────────────
    const handleBuyPlan = (plan) => {
        setPlanCode(plan.planCode);
        setOpenPopup(true);
        setIsRider(true);
        setMemberCount(plan.memberCount);
        setShowMember(false);
    };

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", fn);
        return () => window.removeEventListener("scroll", fn);
    }, []);

    const scrollTo = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); };

    const S = {
        section: { padding: "80px 5%" },
        inner: { maxWidth: 1200, margin: "0 auto" },
    };

    return (
        <div style={{ fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#1a1a2e", background: "#fff", overflowX: "hidden" }}>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&family=Sora:wght@600;700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        html{scroll-behavior:smooth}
        body{overflow-x:hidden}
        .bp{background:linear-gradient(135deg,#0E92CC,#0657A3);color:#fff;border:none;padding:14px 32px;border-radius:50px;font-size:15px;font-weight:600;cursor:pointer;font-family:'DM Sans',sans-serif;transition:opacity .2s,transform .2s}
        .bp:hover{opacity:.88;transform:translateY(-2px)}
        .bo{background:transparent;border:2px solid currentColor;padding:12px 28px;border-radius:50px;font-size:15px;font-weight:600;cursor:pointer;font-family:'DM Sans',sans-serif;transition:all .2s}
        .slabel{font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#0E92CC;margin-bottom:10px}
        .stitle{font-family:'Sora',sans-serif;font-size:clamp(26px,4vw,42px);font-weight:800;line-height:1.18;color:#0b1e40}
        .ssub{font-size:17px;color:#5a6a80;line-height:1.72;margin-top:12px}
        .ic{width:100%;height:100%;object-fit:cover;display:block}
        .plan-section-label{font-size:12px;font-weight:700;color:#0b1e40;margin:12px 0 2px;letter-spacing:.01em}
        .plan-section-sublabel{font-size:11px;color:#8a9ab0;font-weight:400;display:block;margin-bottom:6px}
        /* Divider */
.co-divider {
  width: 1px;
  height: 26px;
  background: rgba(0,0,0,0.2);
}

/* 🔥 Mobile Fix */
@media (max-width: 600px) {

  .co-brand-footer {
    align-items: flex-start;
  }

  

}
        .plan-divider{border:none;border-top:1px solid #eef2f8;margin:10px 0}
        ::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:#f0f0f0}::-webkit-scrollbar-thumb{background:#0E92CC;border-radius:3px}
        @media(max-width:820px){
          .hm{display:none!important}
          .grid2{grid-template-columns:1fr!important}
          .grid3{grid-template-columns:1fr!important}
          .stepsrow{flex-direction:column!important}
          .plans-grid{grid-template-columns:1fr!important}
        }
        @media(min-width:821px){.hd{display:none!important}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
        @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(156,203,61,.4)}70%{box-shadow:0 0 0 10px rgba(156,203,61,0)}}


      `}</style>

            {/* NAVBAR */}
            <nav style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 10, background: scrolled ? "rgba(255,255,255,0.97)" : "transparent", backdropFilter: scrolled ? "blur(16px)" : "none", boxShadow: scrolled ? "0 1px 20px rgba(0,0,0,0.08)" : "none", transition: "all .3s", padding: "0 5%" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 70, maxWidth: 1200, margin: "0 auto" }}>
                    {/* Main Brand Logo */}
                    <a href="/" style={{ display: "inline-block", }}>
                        <img
                            src="assets/img/brand-logo.png"
                            alt="Aarogya"
                            style={{ height: 60, display: "block" }} className="max-md:!h-[60px] max-[375px]:!h-[50px] bg-[#ffffff] p-[10px] rounded-full"
                        />
                    </a>
                    <div className="hm" style={{ display: "flex", gap: 32 }}>
                        {["Home", "Benefits", "Plans", "Testimonials"].map(item => (
                            <button key={item} onClick={() => scrollTo(item.toLowerCase())} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: scrolled ? "#1a1a2e" : "#fff", fontWeight: 500, fontFamily: "'DM Sans',sans-serif", transition: "color .2s" }}>{item}</button>
                        ))}
                    </div>
                    <div className="hm" style={{ display: "flex", gap: 12 }}>
                        <button className="bp" style={{ padding: "9px 22px", fontSize: 14 }} onClick={() => window.open("https://aarogyaopd.com/app/", "_blank")}>Login</button>
                    </div>
                    <button className="hd" onClick={() => setMenuOpen(!menuOpen)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 26, color: scrolled ? "#0657A3" : "#fff" }}>☰</button>
                </div>
                {menuOpen && (
                    <div style={{ background: "#fff", borderTop: "1px solid #eee", padding: "16px 20px", display: "flex", flexDirection: "column", gap: 16 }}>
                        {["Home", "Benefits", "Plans", "Testimonials"].map(i => (
                            <button key={i} onClick={() => scrollTo(i.toLowerCase())} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: "#1a1a2e", fontWeight: 500, textAlign: "left", fontFamily: "'DM Sans',sans-serif" }}>{i}</button>
                        ))}
                        <button className="bp" onClick={() => window.open("https://aarogyaopd.com/app/", "_blank")}>Login</button>
                    </div>
                )}
            </nav>

            {/* HERO */}
            <section id="home" style={{ minHeight: "100vh", position: "relative", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", padding: "120px 5% 80px" }}>
                <img src={IMG.heroBg} alt="" aria-hidden="true" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center 30%" }} />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, rgba(255,255,255,0.45) 0%, rgba(6,87,163,0.65) 30%, rgba(11,30,64,0.80) 100%)" }} />
                <div style={{ position: "absolute", inset: 0, opacity: .03, backgroundImage: "radial-gradient(circle,#fff 1px,transparent 1px)", backgroundSize: "36px 36px" }} />
                <div style={{ position: "relative", maxWidth: 820, width: "100%", textAlign: "center", animation: "fadeUp .85s ease both" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)", borderRadius: 50, padding: "7px 18px", marginBottom: 28, border: "1px solid rgba(255,255,255,0.18)" }}>
                        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#9CCB3D", display: "inline-block", animation: "pulse 2s infinite" }} />
                        <span style={{ color: "#fff", fontSize: 13, fontWeight: 500, letterSpacing: ".02em" }}>Welcome to Aarogya OPD</span>
                    </div>
                    <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(38px,6.5vw,72px)", fontWeight: 800, color: "#fff", lineHeight: 1.06, marginBottom: 24 }}>
                        Where Hospital Care Ends, <span style={{ color: "#9CCB3D" }}>We Begin</span>
                    </h1>
                    <p style={{ color: "rgba(255,255,255,0.84)", fontSize: "clamp(16px,2vw,19px)", lineHeight: 1.72, maxWidth: 580, margin: "0 auto 40px" }}>
                        Save up to 50% on doctor consultations, lab tests, and medicines.<br />No waiting periods. Benefits start from Day 1.
                    </p>
                    <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginBottom: 60 }}>
                        <button className="bp" style={{ background: "#9CCB3D", color: "#1a1a2e", fontSize: 16, padding: "15px 40px" }} onClick={() => scrollTo("plans")}>Explore Plans →</button>
                        <button className="bo" style={{ color: "#fff", borderColor: "rgba(255,255,255,0.5)", fontSize: 16 }} onClick={() => scrollTo("benefits")}>Learn More</button>
                    </div>
                    <div style={{ display: "flex", gap: 0, justifyContent: "center", flexWrap: "wrap", background: "rgba(255,255,255,0.08)", backdropFilter: "blur(12px)", borderRadius: 20, border: "1px solid rgba(255,255,255,0.12)", overflow: "hidden" }}>
                        {[["500+", "Partner Clinics"], ["50%", "Savings on OPD"], ["Day 1", "Instant Benefits"], ["4 Lakh+", "Happy Members"]].map(([v, l], i, arr) => (
                            <div key={l} style={{ flex: 1, minWidth: 120, padding: "20px 24px", borderRight: i < arr.length - 1 ? "1px solid rgba(255,255,255,0.1)" : "none", textAlign: "center" }}>
                                <div style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(20px,3vw,28px)", fontWeight: 800, color: "#9CCB3D" }}>{v}</div>
                                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12, marginTop: 4 }}>{l}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PARTNERS STRIP */}
            <section style={{ padding: "22px 5%", background: "#f8faff", borderBottom: "1px solid #eef2f8" }}>
                <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", gap: 28, flexWrap: "wrap", justifyContent: "center" }}>
                    <span style={{ fontSize: 12, color: "#8a9ab0", fontWeight: 600, letterSpacing: ".06em", textTransform: "uppercase" }}>Trusted partners</span>
                    {partners.map(p => <div key={p} style={{ fontSize: 14, fontWeight: 600, color: "#0657A3", opacity: .6 }}>{p}</div>)}
                </div>
            </section>

            {/* ABOUT / PHILOSOPHY */}
            <section style={{ ...S.section, background: "#fff" }}>
                <div style={{ ...S.inner, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64, alignItems: "center" }} className="grid2">
                    <Anim style={{ height: "auto" }}>
                        <div style={{ position: "relative", height: 480 }}>
                            <div style={{ position: "absolute", top: 0, left: 0, width: "64%", height: "70%", borderRadius: 20, overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.12)" }}>
                                <img src={IMG.consultation} alt="Doctor consulting patient" className="ic" />
                            </div>
                            <div style={{ position: "absolute", bottom: 0, right: 0, width: "58%", height: "62%", borderRadius: 20, overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.12)" }}>
                                <img src={IMG.familyIndian} alt="Indian family" className="ic" />
                            </div>

                            <div style={{ position: "absolute", bottom: 52, left: -12, background: "#fff", borderRadius: 16, padding: "14px 18px", boxShadow: "0 8px 32px rgba(0,0,0,0.1)", border: "1px solid #eef2f8", zIndex: 2 }}>
                                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 22, color: "#0657A3" }}>4 Lakh+</div>
                                <div style={{ fontSize: 12, color: "#5a6a80", marginTop: 2 }}>Happy Families</div>
                            </div>
                        </div>
                    </Anim>
                    <Anim delay={0.15} style={{ height: "auto" }}>
                        <div className="slabel">Our Philosophy</div>
                        <h2 className="stitle">The Heart of Aarogya</h2>
                        <p className="ssub">We believe quality healthcare should never be a luxury. Aarogya OPD was founded to reduce the out-of-pocket medical inflation that affects millions of Indian families every year.</p>
                        <p style={{ fontSize: 15, color: "#5a6a80", lineHeight: 1.75, marginTop: 14 }}>By partnering with 500+ clinics and diagnostic centres, we give every member — from a young professional in Mumbai to an elderly parent in Indore — access to world-class healthcare at prices that actually make sense.</p>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginTop: 28 }}>
                            {[["🤝", "Network", "500+ clinics & diagnostic centres"], ["💡", "Transparency", "No hidden charges or complicated claims"], ["❤️", "Support", "Dedicated health manager for every member"], ["🌱", "Prevention", "Proactive wellness — not just reactive care"]].map(([icon, title, desc]) => (
                                <div key={title} style={{ background: "#f8faff", borderRadius: 14, padding: "16px 14px", border: "1px solid #eef2f8" }}>
                                    <div style={{ fontSize: 22, marginBottom: 6 }}>{icon}</div>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: "#0b1e40", marginBottom: 4 }}>{title}</div>
                                    <div style={{ fontSize: 13, color: "#5a6a80", lineHeight: 1.55 }}>{desc}</div>
                                </div>
                            ))}
                        </div>
                    </Anim>
                </div>
            </section>

            {/* BENEFITS */}
            <section id="benefits" style={{ ...S.section, background: "#f8faff" }}>
                <div style={S.inner}>
                    <Anim style={{ textAlign: "center", marginBottom: 50, height: "auto" }}>
                        <div className="slabel">Our Benefits</div>
                        <h2 className="stitle">Why Choose Aarogya OPD?</h2>
                        <p className="ssub" style={{ maxWidth: 540, margin: "12px auto 0" }}>Everything you need for everyday healthcare — in one affordable membership.</p>
                    </Anim>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 22 }}>
                        {benefits.map((b, i) => (
                            <Anim key={i} delay={i * 0.07}>
                                <div style={{ background: "#fff", borderRadius: 20, overflow: "hidden", border: "1px solid #eef2f8", height: "100%", cursor: "pointer", transition: "transform .25s,box-shadow .25s" }}
                                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 56px rgba(6,87,163,0.11)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                                    <div style={{ height: 190, overflow: "hidden" }}>
                                        <img src={b.img} alt={b.title} style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform .5s" }}
                                            onMouseEnter={e => e.currentTarget.style.transform = "scale(1.06)"}
                                            onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"} />
                                    </div>
                                    <div style={{ padding: "20px 22px 26px" }}>
                                        <div style={{ fontFamily: "'Sora',sans-serif", fontSize: 17, fontWeight: 700, color: "#0b1e40", marginBottom: 8 }}>{b.title}</div>
                                        <p style={{ color: "#5a6a80", fontSize: 14, lineHeight: 1.72 }}>{b.desc}</p>
                                    </div>
                                </div>
                            </Anim>
                        ))}
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section style={{ ...S.section, background: "#fff" }}>
                <div style={S.inner}>
                    <Anim style={{ textAlign: "center", marginBottom: 56, height: "auto" }}>
                        <div className="slabel">How It Works</div>
                        <h2 className="stitle">Your Path to Hassle-Free Health</h2>
                        <p className="ssub">Get started in 3 simple steps — no paperwork, no delays.</p>
                    </Anim>
                    <div style={{ display: "flex", flexDirection: "column", gap: 64 }} className="stepsrow">
                        {steps.map((s, i) => (
                            <Anim key={i} delay={0.1} style={{ height: "auto" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 52, alignItems: "center", direction: i % 2 !== 0 ? "rtl" : "ltr" }} className="grid2">
                                    <div style={{ borderRadius: 24, overflow: "hidden", aspectRatio: "16/10", boxShadow: "0 24px 72px rgba(0,0,0,0.1)", direction: "ltr" }}>
                                        <img src={s.img} alt={s.title} className="ic" />
                                    </div>
                                    <div style={{ direction: "ltr" }}>
                                        <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#0657A3,#0E92CC)", boxShadow: "0 8px 24px rgba(6,87,163,0.3)", marginBottom: 20 }}>
                                            <span style={{ fontFamily: "'Sora',sans-serif", color: "#fff", fontSize: 18, fontWeight: 800 }}>{s.num}</span>
                                        </div>
                                        <h3 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(22px,3vw,30px)", fontWeight: 800, color: "#0b1e40", marginBottom: 14 }}>{s.title}</h3>
                                        <p style={{ color: "#5a6a80", fontSize: 17, lineHeight: 1.78 }}>{s.desc}</p>
                                    </div>
                                </div>
                            </Anim>
                        ))}
                    </div>
                </div>
            </section>

            {/* PLANS */}
            <section id="plans" style={{ ...S.section, background: "#f8faff" }}>
                <div style={S.inner}>
                    <Anim style={{ textAlign: "center", marginBottom: 44, height: "auto" }}>
                        <div className="slabel">Pricing</div>
                        <h2 className="stitle">Choose the Right Plan</h2>
                        <p className="ssub">Transparent pricing. No hidden costs. GST shown clearly.</p>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: 10, marginTop: 20, background: "#fff", borderRadius: 50, padding: "8px 20px", border: "1px solid #e0eaf5", cursor: "pointer" }} onClick={() => setShowGST(!showGST)}>
                            <span style={{ fontSize: 14, color: showGST ? "#8a9ab0" : "#0657A3", fontWeight: showGST ? 400 : 600 }}>Excl. GST</span>
                            <div style={{ width: 44, height: 24, borderRadius: 12, background: showGST ? "#0657A3" : "#cdd5e0", position: "relative", transition: "background .2s" }}>
                                <div style={{ position: "absolute", top: 2, left: showGST ? 22 : 2, width: 20, height: 20, borderRadius: "50%", background: "#fff", transition: "left .2s", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }} />
                            </div>
                            <span style={{ fontSize: 14, color: showGST ? "#0657A3" : "#8a9ab0", fontWeight: showGST ? 600 : 400 }}>Incl. GST</span>
                        </div>
                    </Anim>

                    {/* ── Plans grid — stretch makes all cells the same height ── */}
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 20, alignItems: "stretch" }} className="plans-grid">
                        {plans.map((plan, i) => (
                            // Anim has height:100% by default so it fills the grid cell
                            <Anim key={i} delay={i * 0.08}>
                                {/* Card — flex column so bottom section is always at the bottom */}
                                <div style={{ border: "1px solid #e0eaf5", borderRadius: 20, overflow: "hidden", background: "#fff", boxShadow: "0 2px 16px rgba(0,0,0,0.05)", transition: "transform .2s,box-shadow .2s", height: "100%", display: "flex", flexDirection: "column" }}
                                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 16px 48px rgba(6,87,163,0.1)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.05)"; }}>

                                    {/* Top: name, tag, price — fixed, never grows */}
                                    <div style={{ padding: "22px 20px 6px", flexShrink: 0 }}>
                                        <div style={{ fontFamily: "'Sora',sans-serif", fontSize: 20, fontWeight: 800, color: "#0b1e40", marginBottom: 8 }}>
                                            Aarogya {plan.name}
                                        </div>
                                        <span style={{ display: "inline-block", fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, background: plan.tagBg, color: plan.tagColor, marginBottom: 16 }}>
                                            {plan.tag}
                                        </span>
                                        <div style={{ marginBottom: 18 }}>
                                            <span style={{ fontFamily: "'Sora',sans-serif", fontSize: 38, fontWeight: 800, color: "#0b1e40" }}>
                                                ₹{(showGST ? plan.priceGST : plan.price).toLocaleString()}
                                            </span>
                                            <span style={{ fontSize: 13, color: "#8a9ab0", marginLeft: 4 }}>
                                                + GST{showGST ? " (incl.)" : ""}
                                            </span>
                                        </div>
                                    </div>

                                    <hr className="plan-divider" style={{ margin: "0 20px" }} />

                                    {/* Bottom: features + note + button — grows to fill remaining space */}
                                    <div style={{ padding: "4px 20px 20px", flex: 1, display: "flex", flexDirection: "column" }}>
                                        {/* Feature sections */}
                                        <div style={{ flex: 1 }}>
                                            {plan.sections.map((sec, si) => (
                                                <div key={si}>
                                                    {sec.label && (
                                                        <>
                                                            <hr className="plan-divider" />
                                                            <div className="plan-section-label">{sec.label}</div>
                                                            {sec.sublabel && <span className="plan-section-sublabel">{sec.sublabel}</span>}
                                                        </>
                                                    )}
                                                    {sec.items.map((item, ii) => (
                                                        <div key={ii} style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 7 }}>
                                                            <Check />
                                                            <span style={{ fontSize: 13, color: "#2d3e50", lineHeight: 1.45 }}>{item}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Note — sits just above the button, pinned to bottom */}
                                        <p style={{ fontSize: 11, color: "#8a9ab0", marginTop: 16, lineHeight: 1.5, fontStyle: "italic" }}>
                                            *Note: {plan.note}
                                        </p>

                                        {/* CTA button — always at the very bottom */}
                                        <button className="bp" style={{ width: "100%", marginTop: 14, fontSize: 14, padding: "13px", borderRadius: 50 }} onClick={() => handleBuyPlan(plan)}
                                        >
                                            Buy Plan ↗
                                        </button>
                                    </div>

                                </div>
                            </Anim>
                        ))}
                    </div>

                    <Anim style={{ height: "auto" }}>
                        <div style={{ textAlign: "center", marginTop: 24, fontSize: 13, color: "#8a9ab0" }}>
                            ✅ All plans include the Personal Accident Rider &nbsp;|&nbsp; 🔒 Secure payment &nbsp;|&nbsp; 📞 24/7 support
                        </div>
                    </Anim>
                </div>
            </section >

            {/* CTA BANNER */}
            <section style={{ position: "relative", padding: "90px 5%", overflow: "hidden" }}>
                <img src={IMG.elderly} alt="" aria-hidden="true" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center 30%" }} />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg,rgba(11,30,64,0.94),rgba(6,87,163,0.86))" }} />
                <Anim style={{ maxWidth: 700, margin: "0 auto", textAlign: "center", position: "relative", height: "auto" }}>
                    <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: "clamp(24px,4vw,42px)", fontWeight: 800, color: "#fff", marginBottom: 16 }}>
                        Instant access. Zero waiting.<br />Day 1 benefits.
                    </h2>
                    <p style={{ color: "rgba(255,255,255,0.75)", fontSize: 17, marginBottom: 32 }}>Healthcare that doesn't make you wait. Join thousands of families who trust Aarogya OPD.</p>
                    <button className="bp" style={{ background: "#9CCB3D", color: "#1a1a2e", fontSize: 16, padding: "15px 44px" }} onClick={() => scrollTo("plans")}>Get Started Today →</button>
                </Anim>
            </section >

            {/* TESTIMONIALS */}
            <section id="testimonials" style={{ ...S.section, background: "#fff" }}>
                <div style={S.inner}>
                    <Anim style={{ textAlign: "center", marginBottom: 50, height: "auto" }}>
                        <div className="slabel">Testimonials</div>
                        <h2 className="stitle">See What Our Customers Have to Say</h2>
                    </Anim>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 24 }} className="grid3">
                        {testimonials.map((t, i) => (
                            <Anim key={i} delay={i * 0.1}>
                                <div style={{ background: "#f8faff", borderRadius: 20, padding: "28px 24px", border: "1px solid #eef2f8", height: "100%", display: "flex", flexDirection: "column" }}>
                                    <div style={{ display: "flex", gap: 3, marginBottom: 16 }}>
                                        {Array(t.stars).fill(0).map((_, si) => <span key={si} style={{ color: "#f59e0b", fontSize: 20 }}>★</span>)}
                                    </div>
                                    <p style={{ color: "#2d3e50", fontSize: 15, lineHeight: 1.78, marginBottom: 24, fontStyle: "italic", flex: 1 }}>"{t.text}"</p>
                                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                        <div style={{ width: 46, height: 46, borderRadius: "50%", background: "linear-gradient(135deg,#0657A3,#0E92CC)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18, fontWeight: 700, flexShrink: 0 }}>{t.name[0]}</div>
                                        <div>
                                            <div style={{ fontWeight: 600, fontSize: 15, color: "#0b1e40" }}>{t.name}</div>
                                            <div style={{ fontSize: 13, color: "#8a9ab0" }}>{t.city}</div>
                                        </div>
                                        <div style={{ marginLeft: "auto", fontSize: 52, color: "#0657A3", opacity: .1, fontFamily: "Georgia,serif", lineHeight: .8 }}>"</div>
                                    </div>
                                </div>
                            </Anim>
                        ))}
                    </div>
                </div>
            </section >

            {/* FOOTER */}
            <footer style={{ background: "#0b1e40", color: "#fff", padding: "60px 5% 28px" }}>
                <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 40, marginBottom: 48 }} className="grid2">

                        {/* FIXED LOGO ALIGNMENT */}
                        <div className="co-brand-footer" style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start"
                        }}>

                            {/* Footer Logo */}
                            <a href="/">
                                <img
                                    src="assets/img/brand-logo.png"
                                    alt="Aarogya"
                                    style={{ height: 60, display: "block" }} className="bg-[#ffffff] p-[10px] rounded-full max-md:!h-[60px] max-[375px]:!h-[50px]"
                                />
                            </a>


                            {/* Description */}
                            <p style={{
                                color: "rgba(255,255,255,0.48)",
                                fontSize: 14,
                                lineHeight: 1.75,
                                marginTop: 16,
                                maxWidth: 280
                            }}>
                                We aim to reduce the "out-of-pocket" medical inflation that affects millions of families by providing a structured, subscription-based wellness ecosystem.
                            </p>
                        </div>

                        {[
                            {
                                title: "Quick Links",
                                items: [
                                    { label: "Home", href: "#home" },
                                    { label: "Benefits", href: "#benefits" },
                                    { label: "Plans", href: "#plans" },
                                    { label: "Testimonials", href: "#testimonials" }
                                ]
                            },
                            {
                                title: "Policies",
                                items: [
                                    { label: "Terms & Condition", href: "/term-of-use" },
                                    { label: "Shipping & Delivery", href: "/shipping-delivery-policy" },
                                    { label: "Privacy Policy", href: "/privacy-policy" },
                                    { label: "Cancellation Policy", href: "/cancellation-policy" }
                                ]
                            },
                            {
                                title: "Reach Us",
                                items: [
                                    { label: "LG32, Bansi Trade Center, M G Road, Indore (M.P.) 452001", href: "#" },
                                    { label: "care@aarogyaopd.com", href: "mailto:care@aarogyaopd.com" },
                                    { label: "+91 9826533573", href: "tel:+919826533573" }
                                ]
                            }
                        ].map(col => (
                            <div key={col.title}>
                                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 18 }}>
                                    {col.title}
                                </div>

                                {col.items.map((item, ii) => (
                                    <a
                                        key={ii}
                                        href={item.href}
                                        onClick={(e) => {
                                            if (item.href.startsWith("#")) {
                                                e.preventDefault();
                                                scrollTo(item.href.replace("#", ""));
                                            }
                                        }}
                                        target={item.href.startsWith("http") ? "_blank" : "_self"}
                                        rel="noopener noreferrer"
                                        style={{
                                            display: "block",
                                            color: "rgba(255,255,255,0.46)",
                                            fontSize: 13,
                                            lineHeight: 1.6,
                                            marginBottom: 10,
                                            textDecoration: "none",
                                            transition: "color .2s",
                                            cursor: "pointer"
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.color = "#9CCB3D"}
                                        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.46)"}
                                    >
                                        {item.label}
                                    </a>
                                ))}
                            </div>
                        ))}
                    </div>

                    <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 24, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                        <span style={{ color: "rgba(255,255,255,0.32)", fontSize: 13 }}>
                            © 2026 Aarogya OPD. All Rights Reserved.
                        </span>
                        <span style={{ color: "rgba(255,255,255,0.32)", fontSize: 13 }}>
                            Made with ❤️ for a healthier India
                        </span>
                    </div>
                </div>
            </footer >

            <BuyPlan
                planCode={planCode}
                tenantId={tenantId}
                showPopUp={openPopup}
                setShowPopUp={setOpenPopup}
                isRider={isRider}
                showMember={showMember}
                memberCount={memberCount}
            />
        </div >

        // End Landing Page Here


    );
}